import template from './news-list.html';
import controller from './news-list.controller';

let newsListComponent = {
  bindings: {},
  template,
  controller
};

export default newsListComponent;



// WEBPACK FOOTER //
// ./client/app/components/news/news-list.component.js